module.exports = __webpack_public_path__ + "media/images/manage_groups-cc48faef.svg";